import axios from '@_system/axios/axios.js'
export default {
	path: '/invoice',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	statics(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/statics', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	applyinvoice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/applyinvoice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	overtimeinvoice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/overtimeinvoice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	staticsyear(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/staticsyear', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},

	listoutputinvoice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listoutputinvoice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updateoutputinvoice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/updateoutputinvoice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	getyqdzinventory(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getyqdzinventory', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	getyqdzinvoice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getyqdzinvoice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	createorderyqdzorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/createorderyqdzorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	deleteorderyqdzorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/deleteorderyqdzorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	getorderyqdzorderstatics(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getorderyqdzorderstatics', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	
	listinputinvoice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listinputinvoice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listinvoicecompany(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/listinvoicecompany', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	setinputinvoiceignore(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/setinputinvoiceignore', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	setoutputinvoiceignore(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/setoutputinvoiceignore', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	getrelationinvoice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getrelationinvoice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	getinputinvoicepdf(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getinputinvoicepdf', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getinputinvoicedetail(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getinputinvoicedetail', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	createorderyqdzpurchaseorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/createorderyqdzpurchaseorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	deleteorderyqdzpurchaseorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/deleteorderyqdzpurchaseorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	inputinvoicedetailunittransfer(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/inputinvoicedetailunittransfer', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	inputinvoicedetailunitsave(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/inputinvoicedetailunitsave', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	inputinvoicedetailmatchinventorysave(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/inputinvoicedetailmatchinventorysave', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	
	
	
	getinventory(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getinventory', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getinventoryreport(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getinventoryreport', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getoutputinvoicedetail(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/getoutputinvoicedetail', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	getoutputinvoicematchinfo(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/getoutputinvoicematchinfo', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	initoutputinvoiceorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/initoutputinvoiceorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	initinputinvoiceorder(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/initinputinvoiceorder', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	addmatchgoods(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/addmatchgoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	clearmatchgoods(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/clearmatchgoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	createPurchase(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/createPurchase', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	repurchase(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/repurchase', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	adjustamount(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/adjustamount', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	
	
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/invoice', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	import(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	export (data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/export', data, (res) => {
				resolve(res.data)
			})
		})
	},
}